import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { t } from '../hooks/useT';
import { openGoogleCookiePreferences } from '../utils/googleConsent';

const HIDE_FOOTER = new Set(['/play']);

function hideFooter(pathname: string) {
  if (HIDE_FOOTER.has(pathname)) return true;
  if (/^\/archives\/[^/]+\/play$/.test(pathname)) return true;
  return false;
}

export function SiteFooter() {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [cookiesUnavailable, setCookiesUnavailable] = useState(false);

  if (hideFooter(pathname)) return null;

  const handleManageCookies = async () => {
    setCookiesUnavailable(false);
    const opened = await openGoogleCookiePreferences();
    if (!opened) {
      setCookiesUnavailable(true);
      navigate('/confidentialite#cookies');
    }
  };

  return (
    <footer className="site-footer">
      <nav className="site-footer-nav" aria-label={t('legal.footer')}>
        <Link to="/decouvrir">{t('nav.discover')}</Link>
        <Link to="/comment-jouer">{t('nav.howToPlay')}</Link>
        <Link to="/top">{t('nav.top')}</Link>
        <Link to="/contact">{t('contact.title')}</Link>
        <Link to="/mentions-legales">{t('legal.mentions')}</Link>
        <Link to="/cgu">{t('legal.cgu')}</Link>
        <Link to="/cgv">{t('legal.cgv')}</Link>
        <Link to="/confidentialite">{t('legal.privacy')}</Link>
        <button
          type="button"
          className="site-footer-link-btn"
          onClick={handleManageCookies}
        >
          {t('cookies.manage')}
        </button>
        <Link to="/premium">{t('premium.title')}</Link>
        <Link to="/credits">{t('gallery.credits')}</Link>
      </nav>
      {cookiesUnavailable && (
        <p className="site-footer-cookies-fallback" role="status">
          {t('cookies.unavailable')}{' '}
          <Link to="/confidentialite#cookies">{t('cookies.unavailableLink')}</Link>
        </p>
      )}
      <div className="site-footer-about">
        <p>{t('footer.about')}</p>
      </div>
      <p className="site-footer-copy">
        Dezoom — édité par{' '}
        <a href="https://progragames.com/" target="_blank" rel="noopener noreferrer">
          PrograGames
        </a>
      </p>
    </footer>
  );
}
